const CloseAccount = () => {
  return (
    <>
      <div className=" display-max main-page">
        <h1>Close Account</h1>
      </div>
      <div className=" display-mini display-mob">
        <h1>Close Account</h1>
      </div>
    </>
  );
};

export default CloseAccount;
